export const Texture = () => {
  return (
    <div className="absolute left-0 top-0 w-full h-full bg-repeat mix-blend-multiply pointer-events-none opacity-50 bg-[url('../assets/images/texture-mobile.webp')] md:bg-[url('../assets/images/texture.webp')]" style={{ backgroundSize: "100vw auto" }} />
  )
}